import { render, staticRenderFns } from "./costIncomeReport.vue?vue&type=template&id=279f6d0f&scoped=true&"
import script from "./costIncomeReport.vue?vue&type=script&lang=js&"
export * from "./costIncomeReport.vue?vue&type=script&lang=js&"
import style0 from "./costIncomeReport.vue?vue&type=style&index=0&id=279f6d0f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279f6d0f",
  null
  
)

export default component.exports